import { GLCardTemplate, GLTypography } from "@group-link-one/grouplink-components"
import { format } from "date-fns";

import { GetNotificationsDeliveredResponseRow } from "../../../../Services/messageCenterService/useListNotifications/useListNotifications.types";
// import { useCreateNotificationStore } from "../../ModalCreateNotification/store/createNotification";
// import { useNotificationsStore } from "../store/notifications-store";
import { NotificationsCardsContainer, NotificationStatusContainer } from "./NotificationsCardsStyle";

interface ApresentationNotificationsCardsProps {
  notifications?: GetNotificationsDeliveredResponseRow[]
}

export function ApresentationNotificationsCards({ notifications }: ApresentationNotificationsCardsProps) {
  // const { actions } = useNotificationsStore();
  // const { actions: createNotificationAction } = useCreateNotificationStore();

  // const categoryMap = {
  //   1: {
  //     title: "A-Class",
  //     description: "Informative",
  //   },
  //   2: {
  //     title: "B-Class",
  //     description: "Urgent",
  //   },
  // }

  return (
    <NotificationsCardsContainer>
      {notifications && notifications.map((notification) => (
        <GLCardTemplate.Provider key={notification.id}>
          <GLCardTemplate.Root>

            <GLCardTemplate.Header padding="18px 20px">
              <GLCardTemplate.Column width={35}>
                <GLTypography
                  text={notification.value.title}
                  as="p"
                  color="FONT_COLOR"
                  fontSize={4}
                  weight={600}
                />
              </GLCardTemplate.Column>

              <GLCardTemplate.Column width={18} direction="column" gap={5}>
                <GLTypography
                  text="Last time sent"
                  as="span"
                  color="FONT_COLOR_DARK_GREY"
                  fontSize={3}
                  weight={600}
                />

                <GLTypography
                  text={format(new Date(notification.value.sentAt), "MM/dd/yyyy")}
                  as="p"
                  color="FONT_COLOR"
                  fontSize={4}
                  weight={400}
                />
              </GLCardTemplate.Column>

              <GLCardTemplate.Column width={18} direction="column" gap={5}>
                <GLTypography
                  text="Created at"
                  as="span"
                  color="FONT_COLOR_DARK_GREY"
                  fontSize={3}
                  weight={600}
                />

                <GLTypography
                  text={format(new Date(notification.value.createdAt), "MM/dd/yyyy")}
                  as="p"
                  color="FONT_COLOR"
                  fontSize={4}
                  weight={400}
                />
              </GLCardTemplate.Column>

              <GLCardTemplate.Column width={18} direction="column" gap={5}>
                <GLTypography
                  text="Audience"
                  as="span"
                  color="FONT_COLOR_DARK_GREY"
                  fontSize={3}
                  weight={600}
                />

                <GLTypography
                  text={notification.value.devicesDelivered}
                  as="p"
                  color="FONT_COLOR"
                  fontSize={4}
                  weight={400}
                />
              </GLCardTemplate.Column>

              <GLCardTemplate.Column width={18}>
                <NotificationStatusContainer>
                  <GLTypography
                    text="Delivered"
                    as="p"
                    color="FONT_COLOR"
                    fontSize={3}
                    weight={600}
                  />
                </NotificationStatusContainer>
              </GLCardTemplate.Column>

            </GLCardTemplate.Header>

          </GLCardTemplate.Root>
        </GLCardTemplate.Provider>
      ))}
    </NotificationsCardsContainer>
  );
}
